var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-component',{attrs:{"all-categories":_vm.allCategories,"main-category-data":_vm.mainCategory,"categories":_vm.categories},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.onFetchByLocale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }